import React, { useMemo, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, IconButton, Tooltip, Box } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";
import { useGlobalFilter, useSortBy, useTable } from "react-table";

import { GlobalFilter } from "../../components/GlobalFilter/GlobalFilter";
import { useLists } from "../../context/listContext";
import { toggleProductData } from "../../api/products.api";
import { useAuth } from "../../context/authContext";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import { AntSwitch } from "../../styles/index.sty";
import PuffLoader from "react-spinners/PuffLoader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

export const ProductConfigs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { config } = useAuth();
  const prodData = location?.state?.dataOg;
  const { productConfigsByProductsList, fetchProductConfigsByProductsList } =
    useLists();
  const data = useMemo(
    () => productConfigsByProductsList,
    [productConfigsByProductsList]
  );
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchProductConfigsByProductsList(prodData?.product_id);
  }, [prodData]);
  useEffect(() => {
    if (productConfigsByProductsList.length > 0) {
      setLoading(false);
    }
  }, [productConfigsByProductsList]);
  console.log(prodData);
  console.log(productConfigsByProductsList);
  const columns = useMemo(
    () => [
      {
        Header: "Offer Price",
        accessor: "offer_price",
      },
      {
        Header: "Material",
        accessor: "material",
      },
      {
        Header: "SKU",
        accessor: "sku",
      },
      {
        Header: "Dimensions",
        accessor: "dimensions",
      },
      {
        Header: "Product Warranty",
        accessor: "product_warranty",
      },
      {
        Header: "Product Weight",
        accessor: "product_weight",
      },
      {
        Header: "Stock",
        accessor: "stock",
      },
    ],
    []
  );

  const tableHooks = (hooks) => {
    hooks.visibleColumns.push((columns) => [
      {
        id: "Product Finish Image",
        Header: "Product Image",
        Cell: ({ row }) => (
          <img
            src={row.original?.product_finish_image_file}
            alt={row.original?.product_finish_image_name}
            style={{ width: "10rem", aspectRatio: "1.5", margin: "auto" }}
          />
        ),
      },
      {
        id: "Product Finish Name",
        Header: "Product Finish Name",
        Cell: ({ row }) => {
          return (
            <div className="flex justify-center flex-wrap">
              <p>{row.original?.["product-finish"]?.finish_name}</p>
              <p>₹{row.original?.finish_price}</p>
            </div>
          );
        },
      },
      {
        id: "Product Size Name",
        Header: "Product Size Name",
        Cell: ({ row }) => {
          return (
            <div className="flex justify-center flex-wrap">
              <p>{row.original?.["product-size"]?.size_name}</p>
              <p>₹{row.original?.size_price}</p>
            </div>
          );
        },
      },
      {
        id: "Product Storage Name",
        Header: "Product Storage Name",
        Cell: ({ row }) => {
          return (
            <div className="flex justify-center flex-wrap">
              <p>{row.original?.["product-storage"]?.storage_name}</p>
              <p>₹{row.original?.storage_price}</p>
            </div>
          );
        },
      },
      ...columns,
      {
        id: "Actions",
        Header: "Actions",
        Cell: ({ row }) => {
          return (
            <div className="flex justify-center">
              <Tooltip
                title="edit"
                onClick={() => {
                  // console.log(row.id)
                  navigate("/update-product-config", {
                    state: {
                      data: row.original,
                    },
                  });
                }}
              >
                <IconButton>
                  <InsertPhotoIcon
                    style={{ fontSize: "2rem", color: "#0a305e" }}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip
                title="edit"
                onClick={() => {
                  // console.log(row.id)
                  navigate("/update-product-config", {
                    state: {
                      data: row.original,
                    },
                  });
                }}
              >
                <IconButton>
                  <EditOutlined
                    style={{ fontSize: "2rem", color: "#0a305e" }}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip
                title={`${row.is_active ? "active" : "in-active"}`}
                onClick={() =>
                  toggleProductData(
                    { product_id: row.original.product_id },
                    config,
                    fetchProductConfigsByProductsList
                  )
                }
              >
                <IconButton>
                  {" "}
                  <AntSwitch
                    checked={row.original.is_active ? true : false}
                    inputProps={{ "aria-label": "ant design" }}
                  />
                </IconButton>
              </Tooltip>
            </div>
          );
        },
      },
    ]);
  };

  const tableInstance = useTable(
    { columns, data },
    useGlobalFilter,
    tableHooks,
    useSortBy
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    preGlobalFilteredRows,
    setGlobalFilter,
    state,
  } = tableInstance;

  return (
    <>
      {loading ? (
        <Box sx={style}>
          <PuffLoader loading={loading} size={150} />
        </Box>
      ) : (
        <>
          <div className="flex justify-between w-[95%] m-auto mt-[5rem]">
            <GlobalFilter
              preGlobalFilteredRows={preGlobalFilteredRows}
              setGlobalFilter={setGlobalFilter}
              globalFilter={state.globalFilter}
            />
            <Button
              type="button"
              variant="contained"
              // onClick={handleOpen}
              onClick={() =>
                navigate("/add-product-config", {
                  state: {
                    prodData,
                  },
                })
              }
            >
              Add New
            </Button>
          </div>
          <table {...getTableProps()} className="w-[95%] m-auto mt-10">
            <thead>
              {
                // Loop over the header rows
                headerGroups.map((headerGroup) => (
                  // Apply the header row props
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {
                      // Loop over the headers in each row
                      headerGroup.headers.map((column) => (
                        // Apply the header cell props
                        <th
                          {...column.getHeaderProps()}
                          className="border-4 p-3 bg-[#1976d2] text-white"
                        >
                          {
                            // Render the header
                            column.render("Header")
                          }
                        </th>
                      ))
                    }
                  </tr>
                ))
              }
            </thead>
            {/* Apply the table body props */}
            <tbody {...getTableBodyProps()}>
              {
                // Loop over the table rows
                rows.map((row, index) => {
                  // Prepare the row for display
                  prepareRow(row);
                  return (
                    // Apply the row props
                    <tr {...row.getRowProps()}>
                      {
                        // Loop over the rows cells
                        row.cells.map((cell) => {
                          // Apply the cell props
                          return (
                            //  <td {...cell.getCellProps()} className={`p-5 border-1px bg-blue-300 cursor-pointer`}>
                            <td
                              {...cell.getCellProps()}
                              className={`p-5 border-1px bg-${
                                !row.original.is_active
                                  ? "gray"
                                  : index % 2 === 0
                                  ? "white"
                                  : "blue-300"
                              } cursor-pointer text-center`}
                              style={{
                                background: !row.original.is_active
                                  ? "#b3b3b3"
                                  : null,
                              }}
                            >
                              {
                                // Render the cell contents
                                cell.render("Cell")
                              }
                            </td>
                          );
                        })
                      }
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </>
      )}
    </>
  );
};
